import { IAgendaListPage, IAgendaListPageComponents, IDemandCalculatorPage, IDemandCalculatorPageComponents, IEdgePageComponents, IEdgeUnicornPage, IFilterPage, IFilterPageComponents, IHomePage, ILearningMaterialsPage, ILearningMaterialsPageComponents, INonCustomerPage, INonCustomerPageComponents, IPricingPage, IPricingPageComponents, IRebatesPage, IRebatesPageComponents, IStandardContentPage, IStandardContentPageComponents, ITopicSubNavigationHubPage, ITopicSubNavigationHubPageComponents } from "@/.generated";

/** Maps each page content type UID to its modular blocks field name. */
export const COMPONENTS_FIELD_MAP: Record<string, string> = {
  filter_page: 'filter_page_components',
  non_customer_page: 'non_customer_page_components',
  pricing_page: 'pricing_page_components',
  rebates_page: 'rebates_page_components',
  standard_content_page: 'standard_content_page_components',
  topic_sub_navigation_hub_page: 'topic_sub_navigation_hub_page_components',
  demand_calculator_page: 'demand_calculator_page_components',
  learning_materials_page: 'learning_materials_page_components',
  agenda_list_page: 'agenda_list_page_components',
  home_page: 'home_page_components',
  edge_unicorn_page: 'edge_page_components',
};

export type IContentPageComponents = IStandardContentPageComponents | ITopicSubNavigationHubPageComponents | IFilterPageComponents | INonCustomerPageComponents | IPricingPageComponents | IRebatesPageComponents | ILearningMaterialsPageComponents | IAgendaListPageComponents | IEdgePageComponents | IDemandCalculatorPageComponents
/**
* Union of all page content types.
* Add IPageType3 here after running `npm run tsgen` once Page Type 3 is added to the CMS.
*/
export type AnyPage = IStandardContentPage | ITopicSubNavigationHubPage | IFilterPage | INonCustomerPage | IPricingPage | IRebatesPage | ILearningMaterialsPage | IAgendaListPage | IHomePage | IEdgeUnicornPage | IDemandCalculatorPage;

/** Derived from COMPONENTS_FIELD_MAP — add new page types here only. */
export const PAGE_CONTENT_TYPES = Object.keys(COMPONENTS_FIELD_MAP);

export const AGENDA_LIST_DEFAULT_TIME = '9:30am MST';

/** Static destination for "Log in" data-layer click tracking (Header, stickyTile, stickyTileLogin) — SRP-711. */
export const MY_ACCOUNT_LOGIN_URL = 'https://myaccount.srpnet.com/';

/** Arizona stays on MST year-round — no DST */
export const MST_TZ = 'America/Phoenix';
